import { useCallback, useEffect, useState } from 'react';

type UseDebouncedSearchProps = {
  initialValue?: string;
  delay?: number;
  onSearchChange: (value: string) => void;
};

export const useDebouncedSearch = ({
  initialValue = '',
  delay = 500,
  onSearchChange,
}: UseDebouncedSearchProps) => {
  const [searchInput, setSearchInput] = useState(initialValue);

  // Sync with external changes (like URL params)
  useEffect(() => {
    setSearchInput(initialValue);
  }, [initialValue]);

  // Debounced effect for search
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      onSearchChange(searchInput);
    }, delay);

    return () => clearTimeout(timeoutId);
  }, [searchInput, delay, onSearchChange]);

  const handleSearchChange = useCallback((value: string) => {
    setSearchInput(value);
  }, []);

  const clearSearch = useCallback(() => {
    setSearchInput('');
  }, []);

  return {
    searchInput,
    handleSearchChange,
    clearSearch,
  };
};
